module.exports = __webpack_public_path__ + "static/media/16.967b8281.jpg";